<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19 14"
    aria-hidden="true"
  >
    <g transform="translate(-356.109 -1423.011)">
      <g
        data-name="Rectangle 43"
        transform="translate(356.109 1423.011)"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
      >
        <rect width="19" height="14" rx="3" stroke="none" />
        <rect x="0.9" y="0.9" width="17.2" height="12.2" rx="2.1" fill="none" />
      </g>
      <path
        d="M8794.959,2171.2l7.873,5.858,8.025-5.858"
        transform="translate(-8437.357 -745.244)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.8"
      />
    </g>
  </svg>
</template>
